import * as fld from './Fields';
import * as Yup from 'yup';


const sellerRegisterSchema = Yup.object().shape({
    first_name: fld.validFirstName,
    last_name: fld.validFirstName,
    email: fld.validEmail,
    mob_number: fld.validMobNumer,
    location_city: fld.validFirstName,

});

const sellerSendOtpToLoginSchema = Yup.object().shape({
    mob_number: fld.validMobNumer
});

const sellerLoginSchema = Yup.object().shape({
    mob_number: fld.validMobNumer,
    otp: fld.validOtp,
});

const sellerBidListingSchema = Yup.object().shape({
    page_no: fld.validPageNo,
});

const sellerResponseOnBidSchema = Yup.object().shape({
    quantity: fld.validQuantity,
    bid_price: fld.validBidPrice,
    comment: fld.validComment,
    // price_with_gst: fld.validPrice,
    // price_without_gst: fld.validPrice,
    // discount_on_mrp: fld.validPrice,
    // discount_on_ptr: fld.validPrice,
    // product_expiry: fld.validBidValidTill,
});

const sellerUpdateProfileSchema = Yup.object().shape({
    first_name: fld.validFirstName,
    last_name: fld.validFirstName,
    location_city: fld.validFirstName,
});

const selleFeedbackSchema = Yup.object().shape({
    user_name: fld.validFirstName,
    description: fld.validComment,
    mob_number: fld.validMobNumer,
    email: fld.validEmailAllowChars,
});


export default { 
    sellerRegisterSchema, 
    sellerSendOtpToLoginSchema, 
    sellerLoginSchema, 
    sellerBidListingSchema, 
    sellerResponseOnBidSchema,
    sellerUpdateProfileSchema,
    selleFeedbackSchema,
};